import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../../components/loading';

import UpdatePanel from './update-panel';
import ContinuePanel from '../../../../components/continue-panel';
import DialogPrompt from './dialog-prompt';
import HelpMessage from './help-message';

import {
  createGsheet,
  readGsheet,
  deleteGsheet,
  updateColumn,
  getColumnIndexName,
  updateColumnByColumn,
} from '../../../../components/gsheet';

import loadFromLocalDB from '../hivdb/load-db';

import downloadWorkbook from '../../../../components/workbook/download';

import TableConfig from './table-config';

export default class GsheetTable extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    isNavClick: PropTypes.bool.isRequired,
    onCleanPathName: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      showValidateDialog: false,
      showSubmit: false,
      loadGSheet: false,
      disableButtons: false,
      sheet: "Sequences",
    };
  }

  set processing(value) {
    if (value) {
      this.setState({
        loadGSheet: true,
        disableButtons: true,
      });
    } else {
      this.setState({
        loadGSheet: false,
        disableButtons: false,
      });
    }
  }

  async componentDidMount() {
    const {rawDataCollection} = this.props;

    if (rawDataCollection.hasCloneSequence) {
      TableConfig.showColumn('cloneName');
      TableConfig.showColumn('cloneMethod');
    } else {
      TableConfig.hideColumn('cloneName');
      TableConfig.hideColumn('cloneMethod');
    }

    if (rawDataCollection.reference.loadFrom === 'HIVDB') {
      // TableConfig.disableColumn('gene');
      // TableConfig.disableColumn('seqRange');
      // TableConfig.disableColumn('seqLength');
      // TableConfig.disableColumn('numStopIndelX');
      // TableConfig.disableColumn('numApobec');
      // TableConfig.disableColumn('numUnusual');
      // TableConfig.disableColumn('stopIndelX');
      // TableConfig.disableColumn('apobec');
      // TableConfig.disableColumn('unusual');
      TableConfig.showColumn('seqMethod');
      TableConfig.showColumn('isChild');
      TableConfig.showColumn('existingPatientId');
    }

    await this.handleCreateGsheet();

    // window.addEventListener('beforeunload',
    //   this.handleDeleteGsheet(this.props.rawDataCollection.spreadsheet_id)
    // );
  }

  async componentDidUpdate(prevProps) {
    if (this.props.isNavClick !== prevProps.isNavClick) {
      if (this.props.isNavClick) {
        await this.handleContinue();
      }
    }
  }

  get formats() {
    return TableConfig.format;
  }

  get table() {
    const {rawDataCollection} = this.props;
    return TableConfig.getBody(rawDataCollection);
  }

  get title() {
    const {rawDataCollection: {references}} = this.props;
    const firstRef = references[0];
    const title = `${firstRef.author}. ` + (
      firstRef.medlineId ? `(PMID: ${firstRef.medlineId})`: ''
    );

    return title;
  }

  async handleCreateGsheet() {
    this.processing = true;

    const {table, formats, title} = this;
    const {sheet} = this.state;

    const {rawDataCollection, onUpdate} = this.props;

    let spreadsheet_id = rawDataCollection.spreadsheet_id;
    let file_info = await createGsheet(
      spreadsheet_id, title, sheet, table, formats);

    if ((
      rawDataCollection.spreadsheet_id != file_info.spreadsheet_id) || (
        rawDataCollection.sheet_id != file_info.sheet_id)) {
      rawDataCollection.spreadsheet_id = file_info.spreadsheet_id;
      rawDataCollection.sheet_id = file_info.sheet_id;
      onUpdate(rawDataCollection);
    }

    this.processing = false;
  }

  handleDeleteGsheet(spreadsheet_id) {
    if (!spreadsheet_id) {
      return null;
    }

    return async () => {
      await deleteGsheet(spreadsheet_id);
    };
  }

  async handleUpdateColumn(method, property_name, value) {
    this.processing = true;

    const {sheet} = this.state;

    if (method === 'by_column') {
      const column_name = TableConfig.getCaption(property_name);
      await updateColumnByColumn(
        this.props.rawDataCollection.spreadsheet_id,
        sheet,
        getColumnIndexName(TableConfig.headers, column_name),
        getColumnIndexName(TableConfig.headers, TableConfig.getCaption(value)),
      );
    } else {
      const column_name = TableConfig.getCaption(property_name);
      await updateColumn(
        this.props.rawDataCollection.spreadsheet_id,
        sheet,
        getColumnIndexName(TableConfig.headers, column_name),
        TableConfig.toUI(property_name, value),
      );
    }

    this.processing = false;
  }

  async handleContinue() {
    this.processing = true;

    const {sheet} = this.state;
    let rows = await readGsheet(this.props.rawDataCollection.spreadsheet_id, sheet);

    let {rawDataCollection} = this.props;
    rawDataCollection = TableConfig.update(rows, rawDataCollection);

    if (rawDataCollection.hasMessage()) {
      this.setState({
        showValidateDialog: true,
        showSubmit: false,
      });
    } else {
      rawDataCollection = await loadFromLocalDB(rawDataCollection);
      rawDataCollection.validate();

      if (rawDataCollection.messages('rawSequences').length > 0) {
        this.setState({
          showValidateDialog: true,
          showSubmit: false,
        });
      } else {
        this.setState({
          showValidateDialog: true,
          showSubmit: true,
        });
      }

    }

    this.processing = false;

  }

  async handleSubmit() {
    this.processing = true;

    let {rawDataCollection} = this.props;
    const {onUpdate, onSubmit} = this.props;

    await onUpdate(rawDataCollection);

    onSubmit();
  }

  handleDownload() {
    this.processing = true;

    const {rawDataCollection} = this.props;

    downloadWorkbook(rawDataCollection);

    this.processing = false;
  }

  handleCloseDialog() {
    this.setState({
      showValidateDialog: false
    });
    this.props.onCleanPathName();
  }

  render() {
    const {rawDataCollection} = this.props;

    if (!rawDataCollection.hasRawSequences) {
      return null;
    }

    if (this.state.loadGSheet) {
      return <Loading />;
    }

    return (
      <div>
        <div>
          <UpdatePanel
           rawDataCollection={rawDataCollection}
           onUpdateColumn={this.handleUpdateColumn.bind(this)}
           onUpdateDataSet={this.props.onUpdate.bind(this)}
           disabled={this.state.disableButtons}
          />
          <hr/>
        </div>
        <div>
          <ContinuePanel
           onSubmit={this.handleContinue.bind(this)}
           onDownload={this.handleDownload.bind(this)}
           disabled={this.state.disableButtons}
           dom={"span"}
           continueText={"Enter Rx history data"}
          />
          <HelpMessage />
          <DialogPrompt
           rawDataCollection={rawDataCollection}
           showDialog={this.state.showValidateDialog}
           showSubmit={this.state.showSubmit}
           onClose={
             this.handleCloseDialog.bind(this)}
           onSubmit={
             this.handleSubmit.bind(this)}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_seq/index.js